module.exports = __webpack_public_path__ + "static/media/support-icon.135d403c.svg";